import dataMixin from './data-mixin';
import {mapMutations} from "vuex";
import {isEqual, isEmpty, cloneDeep} from 'lodash';

export default function (watchPath = 'persistentData.projekt') {
    return {
        mixins: [
            dataMixin('data', watchPath),
            dataMixin('formIsDirty', 'transientData.formIsDirty', false),
        ],
        computed: {
            computedPersistentData() {
                return cloneDeep(this.data);
            }
        },
        methods: {
            ...mapMutations('formData', ['resetFormData']),
        },
        watch: {
            computedPersistentData: {
                handler(newVal, oldVal) {
                    if (this.formIsDirty === true) {
                        return;
                    }

                    if (isEmpty(oldVal) === false && isEmpty(newVal) === false
                        && isEqual(newVal, oldVal) === false
                    ) {
                        this.formIsDirty = true;
                    }
                },
                deep: true
            }
        },
        created() {
            window.addEventListener('beforeunload', (event) => {
                if (this.formIsDirty) {
                    event.preventDefault();
                    event.returnValue = '';
                }
            }, false);
        }
    }
}
